import {
  GET_STARTED_URL,
  QUICKCASA_HOME_URL,
  QUICKCASA_PRIVACY_URL,
  QUICKCASA_TERMS_URL,
} from '../../_data/marketingLinks'
import {
  BrandBlurb,
  BrandColumn,
  BrandLine,
  ColumnHeader,
  ColumnList,
  Copyright,
  ExternalLink,
  Footer,
  FooterInner,
  InternalLink,
  LegalLink,
  LegalLinks,
  LegalRow,
} from './styled'

const CURRENT_YEAR = new Date().getFullYear()

const MarketingFooter = (): JSX.Element => (
  <Footer>
    <FooterInner>
      <BrandColumn>
        <BrandLine>QuickCal</BrandLine>
        <BrandBlurb>
          Native scheduling for the QuickCasa platform. Booking pages, team
          calendars, and embeddable widgets — billed by usage, not by seat.
        </BrandBlurb>
      </BrandColumn>
      <div>
        <ColumnHeader>Product</ColumnHeader>
        <ColumnList>
          <li>
            <InternalLink to="/features">Features</InternalLink>
          </li>
          <li>
            <InternalLink to="/use-cases">Use cases</InternalLink>
          </li>
          <li>
            <ExternalLink href={GET_STARTED_URL}>Get started</ExternalLink>
          </li>
        </ColumnList>
      </div>
      <div>
        <ColumnHeader>QuickCasa</ColumnHeader>
        <ColumnList>
          <li>
            <ExternalLink href={QUICKCASA_HOME_URL}>The platform</ExternalLink>
          </li>
          <li>
            <ExternalLink href={`${QUICKCASA_HOME_URL}/contact`}>
              Contact
            </ExternalLink>
          </li>
        </ColumnList>
      </div>
      <div>
        <ColumnHeader>Booking</ColumnHeader>
        <ColumnList>
          <li>
            <BrandBlurb>
              Trying to book a time with an agent? Use the link from your
              invitation email.
            </BrandBlurb>
          </li>
        </ColumnList>
      </div>
    </FooterInner>
    <LegalRow>
      <Copyright>© {CURRENT_YEAR} QuickCasa. All rights reserved.</Copyright>
      <LegalLinks>
        <LegalLink href={QUICKCASA_PRIVACY_URL}>Privacy</LegalLink>
        <LegalLink href={QUICKCASA_TERMS_URL}>Terms</LegalLink>
      </LegalLinks>
    </LegalRow>
  </Footer>
)

export default MarketingFooter
